/**
 * The hero's light: a single static layer of radial gradients (sunlight around the
 * point where the fiber tips converge, a cool corner, and a veil that keeps the
 * headline readable), so the hero is composed before the WebGL field arrives and
 * stays complete without it. Gradients live in src/styles/brand.css (.hero-light).
 *
 * Costs nothing at runtime: no blur, no blend mode, no filter, no per-frame work. It
 * is painted once and fades in with a one-time CSS animation (compositor only).
 * Sits behind the hero text (-z-10), above the fixed fiber canvas. Decorative.
 */
export function SunHalo() {
	return <div aria-hidden className="hero-light pointer-events-none absolute inset-0 -z-10" />;
}
